import { render, staticRenderFns } from "./patientDetails.vue?vue&type=template&id=177c1e9f"
import script from "./patientDetails.vue?vue&type=script&lang=js"
export * from "./patientDetails.vue?vue&type=script&lang=js"
import style0 from "./patientDetails.vue?vue&type=style&index=0&id=177c1e9f&prod&lang=scss"
import style1 from "./patientDetails.vue?vue&type=style&index=1&id=177c1e9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports